/**
 * Order Notifications component
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */
import { Component } from '@angular/core';
import { WdOrdersV2Service } from '../../services/orders/wd-orders-v2.service';
import { WdLocalEnvironmentService } from '../../services/environment/wd-local-environment.service';

@Component({
  selector: 'app-order-notifications',
  templateUrl: './order-notifications.component.html',
  styleUrls: ['./order-notifications.component.scss'],
})
export class OrderNotificationsComponent {
  notificationButtonType = 'default';

  notificationsCount = 0;

  /**
   * Constructor Initialization
   */
  constructor(
    public wdOrdersService: WdOrdersV2Service,
    public wdEnvironmentService: WdLocalEnvironmentService,
  ) {
    this.notificationsCount = this.wdOrdersService.orderShippingNotifications.length;

    // Show the notifications button in red if there are notifications
    this.notificationButtonType =
      this.notificationsCount > 0 ? 'outlineDanger' : 'default';
  }

  /**
   * Get the work order details page URL for the order index
   */
  getOrderDetailsUrl(index: number) {
    return this.wdEnvironmentService.resources.getWorkOrderDetailsUrl(index);
  }
}
